import React, { Component } from "react";
import { Image, Form, Button, Modal, Spinner } from "react-bootstrap";
import EditImage from "../../../../assets/edit-image.svg";
import { PmgTableTemplate } from "../../../reusableComponent";
import { pmgInvestListHeaderOptions } from "../CmsManagement.constant";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CreateUser from "../../../../assets/create-user-icon.svg";
import CreateSectionForm from "./CreateSectionForm";
import { userGroup } from "../../../../utils/userDetails";
import CheckMark from "../../../../assets/CheckMark.svg";
import {
  getLocalstorage,
  isValidArray,
  removeItemFromLocalStorage
} from "../../../../helper";
import { get, isNull } from "lodash";
import PermissionHOC from "../../../PermissionHOC";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getSectionInvestAction,
  getHeadingAction,
  headingAddAction,
  editHeadingAction
} from "../../../../actions/pmgTeam.action";
import { LoaderPage } from "../../../../component/Loader";
import { headingUpdate } from "../../../../services/apiServices";
import { getHeadingg } from "../../../../services/apiServices";
import request from "../../../../services/requestService";
import { PmgTeamDropDownOptions } from "../../../reusableComponent";
import { TableTemplate } from "../../../reusableComponent/tableListing/cmstemplate";
const Params = {
  active: true
};

class SectionListing extends Component {
  constructor(props) {
    super(props);
    this.sectionModelRef = React.createRef();
    this.state = {
      offset: 0,
      filteredArray: [],
      noFilterData: false,
      searchInputData: "",
      isEdit: false,
      paginationoffset: 0,
      showBubbleFilter: false,
      selectedFilter: null,
      makeSelectedNull: false,
      showTable: false,
      displayModal: false,
      isPmgActive: true,
      data: true,
      makeUserActiveInfo: null,
      pmgHeading: "SECTION Officials",
      pmgHeadingId: 2,
      pmgData: [],
      usersListParams: { ...Params },
      groupData: {},
      isMakeUserApiLoading: false,
      isEditingHeading: false,
      isSuperAdmin: false,
      currentPage: 1,
      recordsPerPage: 10,
      tableData: [],
      showLoader: true,
      checkboxLoader: false
    };
  }

  getInvestiListingData = async () => {
    let pmgInvestData = await getSectionInvestAction(this.state.isPmgActive);
    let heading = await getHeadingAction();
    //console.log(heading);
    if (pmgInvestData) {
      this.setState({
        pmgData: pmgInvestData.data,
        showLoader: false
      });
    }

    if (heading) {
      //console.log("getInvestiListingData", heading);
      this.setState({
        pmgHeading: heading.data.dropDown[2].title,
        pmgHeadingId: heading.data.dropDown[2].id
      });
    }
  };
  async componentDidMount() {
    this.getInvestiListingData();
    const { selectedTab } = this.props;
    this.setState({ pmgHeading: selectedTab });
  }

  handleCheckbox = async () => {
    const { isPmgActive } = this.state;
    this.setState({
      isPmgActive: !isPmgActive,
      checkboxLoader: true
    });
    let data = await getSectionInvestAction(!this.state.isPmgActive);
    if (data.status == true) {
      setTimeout(() => {
        this.setState({ checkboxLoader: false });
      }, 1000);
    }
    this.setState({
      pmgData: data.data
    });
  };

  userListApiCalling = e => {
    e.preventDefault();
    e.stopPropagation();
    const { getUsersListDispatch } = this.props;
    const { isPmgActive } = this.state;
    try {
      if (isPmgActive === true) {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: true
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      } else {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: false
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleClose = e => {
    this.setState({ isEdit: false });
  };

  handleReorder = updatedPmgData => {
    this.setState({ pmgData: updatedPmgData });
  };

  onToggleModal = (e, value) => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onEdit = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    const editKey = getLocalstorage("editkey");
    if (editKey && Object.values(editKey)[0] !== null) {
      this.setState(
        {
          groupData: value
        },
        () => {
          this.isIndexingRuningAtBackend(editKey);
        }
      );
    } else {
      removeItemFromLocalStorage("editkey");
      this.setState(prevState => ({
        isEdit: !prevState.isEdit,
        groupData: value
      }));
    }
  };
  onEditHeading = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ isEditingHeading: true });
  };

  onEditClick = async e => {
    this.setState({ isEditingHeading: false, showLoader: true });
    const payloadForEdit = {
      title: this.state.pmgHeading
    };
    const response = await request(
      headingUpdate(payloadForEdit, this.state.pmgHeadingId)
    );
    const response1 = await request(getHeadingg());
    const updatedArray = PmgTeamDropDownOptions.map((item, index) => {
      // Check if it's the first object (index 0)
      if (index === 0) {
        // Create a new object with updated dropDown
        return {
          ...item,
          dropDown: response1.data.data.dropDown
        };
      } else {
        // Return the original item for other objects
        return item;
      }
    });
    this.props.onSectionChange(
      updatedArray,
      response1.data.data.dropDown[2].title
    );
    this.setState({ showLoader: false });
  };

  handleEditHeading = e => {
    this.setState({ pmgHeading: e.target.value });
  };

  handleEditConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();
    const payloadForEdit = {
      name: this.props.groupData.name
        ? this.props.groupData.name
        : this.state.name
    };
    const responseData = await editHeadingAction(
      payloadForEdit,
      this.props.groupData.name
    );
    // console.log("from edit", responseData);
    return responseData;
  };

  handleAddMemberConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();
    const payloadForCreate = {
      name: this.state.name
    };
    const response = await headingAddAction(payloadForCreate);
    return response;
  };

  callApiOnSuccess = data => {
    this.setState({ showLoader: true });
    if (Object.keys(data).length > 0) {
      this.getInvestiListingData();
    }
  };

  handlePageChange = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };
  render() {
    const { onMakeUserActive, onCloseModal } = this;
    const {
      pmgData,
      name,
      displayModal,
      isEdit,
      groupData,
      isEditGroup,
      isPmgActive,
      heading,
      data,
      isApiLoading,
      active,
      isMakeUserApiLoading,
      pmgHeading,
      isEditingHeading,
      currentPage,
      recordsPerPage
    } = this.state;
    const { permission } = this.props;
    let isUserGroupCentralPMG = userGroup.centralPMG.PMG_SuperAdmin;

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = pmgData.slice(indexOfFirstRecord, indexOfLastRecord);

    // Calculate total number of pages
    const totalPages = Math.ceil(pmgData.length / recordsPerPage);

    const renderPagination = () => {
      const pageNumbers = [];
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <li key={i} className={i === currentPage ? "active" : ""}>
            <div
              onClick={() => this.handlePageChange(i)}
              className={i === currentPage ? "active_page" : "disable_page"}
            >
              {i}
            </div>
          </li>
        );
      }
      return pageNumbers;
    };
    //console.log(this.state.isSuperAdmin, "superadmin");

    return (
      <>
        <LoaderPage loading={this.state.showLoader} />
        <div className="pmg-management pmg-listing">
          <div className="header ">
            <div className="d-flex flex-row">
              {this.props.headingDetailsData.isHeaderEditable ? (
                <>
                  {isEditingHeading && (
                    <div className="d-flex gap-2">
                      <Form.Control
                        name="name"
                        type="text"
                        value={
                          this.state.pmgHeading !== null
                            ? this.state.pmgHeading
                            : ""
                        }
                        maxLength="40"
                        // onChange={this.handleChange}
                        onChange={e => this.handleEditHeading(e)}
                        className="field-width"
                        style={{
                          width: "256px",
                          height: "50px",
                          fontFamily: "Metropolis"
                        }}
                      />
                      <Image
                        className="edit-image"
                        src={CheckMark}
                        onClick={e => {
                          this.onEditClick(e);
                        }}
                      />
                    </div>
                  )}

                  {this.props.headingDetailsData.isHeaderEditable &&
                    !isEditingHeading && (
                      <div className="d-flex gap-2">
                        <h3 className="mt-2">{pmgHeading}</h3>
                        <Image
                          className="edit-image"
                          src={EditImage}
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.onEditHeading(e);
                          }}
                        />
                      </div>
                    )}
                </>
              ) : (
                <h3 className="mt-2">{pmgHeading}</h3>
              )}

              <Form.Check
                className={`form-checkbox pl-4 ${
                  isPmgActive === true ? "checked" : ""
                }`}
                disabled={!get(permission, "canViewOnlyProject")}
              >
                <Form.Check.Input type="checkbox" />
                <Form.Check.Label
                  className="d-flex active-check-mark"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleCheckbox(e);
                  }}
                >
                  <div className="active-check-label">ACTIVE USERS</div>
                </Form.Check.Label>
              </Form.Check>
            </div>
            <div className="header-buttons d-flex flex-row">
              <OverlayTrigger
                trigger="hover"
                defaultShow={false}
                placement="bottom"
                overlay={
                  <Tooltip
                    id={`tooltip-checking`}
                    className="create_project_tolltip"
                  >
                    Add New Member
                  </Tooltip>
                }
              >
                <Button
                  className={`btn-orange create-btn 
                }`}
                  size="sm"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onToggleModal(e);
                  }}
                >
                  <div>
                    <Image src={CreateUser} className="create-user" />
                  </div>
                </Button>
              </OverlayTrigger>
            </div>
          </div>
          {this.props.headingDetailsData.isHeaderEditable ? (
            <div className="pmgtable">
              <PmgTableTemplate
                bodyOptions={pmgData}
                isPmgTable={true}
                calledFrom="SEC"
                onReorder={data => {
                  this.handleReorder(data);
                }}
                checkboxLoader={this.state.checkboxLoader}
                headersOptions={pmgInvestListHeaderOptions}
                bodyTemplate={(options, index) => {
                  return (
                    <>
                      <td>{index + 1}</td>
                      <td>{options.name}</td>
                      <td>{options.designation}</td>
                      <td>{options.active ? "Yes" : "No"}</td>
                      <td>
                        <Image
                          className={"edit-image"}
                          src={EditImage}
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.onEdit(e, options);
                          }}
                        />
                      </td>
                    </>
                  );
                }}
                headersTemplate={options => (
                  <>
                    <th className="pe-5">{options.title}</th>
                  </>
                )}
              />
            </div>
          ) : (
            <TableTemplate
              isUsersTable={true}
              //  isBestPracticesTable={true}
              isEdit={true}
              headersOptions={pmgInvestListHeaderOptions}
              bodyOptions={pmgData}
              bodyTemplate={(options, index) => (
                <>
                  <td>{index + 1}</td>
                  <td>{options.name}</td>
                  <td>{options.designation}</td>
                  <td>{options.active ? "Yes" : "No"}</td>

                  <td>
                    <Image
                      className={"edit-image"}
                      src={EditImage}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.onEdit(e, options);
                      }}
                    />
                  </td>
                </>
              )}
              headersTemplate={options => (
                <>
                  <th className="pe-5">{options.title}</th>
                </>
              )}
            />
          )}

          <div>
            {/* Pagination */}
            {/* <ul className="pagination">
            <li>
              <button
                onClick={() =>
                  this.handlePageChange(currentPage > 1 ? currentPage - 1 : 1)
                }
                disabled={currentPage === 1}
                className="arrow_btn"
              >
                &#8249;
              </button>
            </li>
            {renderPagination()}
            <li>
              <button
                onClick={() =>
                  this.handlePageChange(
                    currentPage < totalPages ? currentPage + 1 : totalPages
                  )
                }
                className="arrow_btn"
                disabled={currentPage === totalPages}
              >
                &#8250;
              </button>
            </li>
          </ul> */}
          </div>
          {/*  Create Modal **/}
          <Modal
            size="lg"
            show={displayModal}
            onHide={e => {
              this.onToggleModal(e);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
            className="content-modal  create-user-form"
          >
            <div className="modal-box-shadow" ref={this.sectionModelRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  Add Members
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="body-modal-cms  create-user-body-modal">
                <CreateSectionForm
                  togglePopUp={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onToggleModal(e);
                  }}
                  callApiOnSuccess={this.callApiOnSuccess}
                  sectionModelRef={this.sectionModelRef}
                />
              </Modal.Body>
            </div>
          </Modal>
          {/*  Create Modal End **/}

          <Modal
            size="lg"
            show={isEdit}
            onHide={e => {
              this.handleClose(e);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
            className="edit-user-modal-form"
          >
            <div className="modal-box-shadow" ref={this.sectionModelRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  {!get(permission, "canViewOnlyProject")
                    ? "Edit Members"
                    : "View Members"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="body-modal-cms create-group">
                <CreateSectionForm
                  togglePopUp={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onEdit(e);
                  }}
                  isEdit={isEdit}
                  groupData={groupData}
                  isEditGroup={isEditGroup}
                  callApiOnSuccess={this.callApiOnSuccess}
                  edit
                  active={active}
                  permission={permission}
                  isMakeUserApiLoading={isMakeUserApiLoading}
                  isApiLoading={isApiLoading}
                  sectionModelRef={this.sectionModelRef}
                />
              </Modal.Body>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    headingDetailsData: state.pmgReducer.headingDetailsData
  };
}

export default connect(
  mapStateToProps,
  {
    editHeadingAction
  }
)(PermissionHOC(SectionListing));
